import { ConnectedPosition } from '@angular/cdk/overlay';

import { SpotlightKey } from '@reach/interfaces/spotlights/spotlights.enum';

export type MessagePosition = Pick<ConnectedPosition, 'overlayX' | 'overlayY'>;

export enum OnboardingCondition {
	ADVANCED_SEARCH_VISIBLE = 'ADVANCED_SEARCH_VISIBLE',
	SIDE_MENU_OPENED = 'SIDE_MENU_OPENED',
	GENERIC_MENU_FULLY_OPENED = 'GENERIC_MENU_FULLY_OPENED',
	YOUTUBE_VIDEO = 'YOUTUBE_VIDEO',
	POPUP_OPENED = 'POPUP_OPENED',
	LATERAL_CHAT_OPENED = 'LATERAL_CHAT_OPENED',
	EDITING_NOTE = 'EDITING_NOTE',
	NEW_RELEASE_INFO = 'NEW_RELEASE_INFO',
	FULL_PAGE_OPENED = 'FULL_PAGE_OPENED',
}

export interface SpotlightConfigItemScrens<T> {
	base: T;
	mobile?: T;
	desktop?: T;
}

export type SpotlightConfigItem<T> = T | SpotlightConfigItemScrens<T>;

interface OnboardingConfigBase {
	withPoint: boolean;
	withMessage: boolean;
	withMoreInfoButton: boolean;
	gotItButton: boolean;
	messagePosition?: SpotlightConfigItem<MessagePosition>;
	justPopUp: boolean;

	notBefore: SpotlightConfigItem<SpotlightKey[]>;

	onlyWhenConditions: SpotlightConfigItem<OnboardingCondition[]>;
	notWhenConditions: SpotlightConfigItem<OnboardingCondition[]>;
}

interface OnboardingConfigPopup extends OnboardingConfigBase {
	withPoint: false;
	withMessage: false;
	gotItButton: false;
	withMoreInfoButton: false;
	justPopUp: true;
}

interface OnboardingConfigJustPoint extends OnboardingConfigBase {
	withPoint: true;
	withMessage: false;
	gotItButton: false;
	withMoreInfoButton: false;
	justPopUp: false;
}

interface OnboardingConfigJustMessage extends OnboardingConfigBase {
	withPoint: false;
	withMessage: true;
	withMoreInfoButton: boolean;
	justPopUp: false;
	messagePosition: SpotlightConfigItem<MessagePosition>;
}

interface OnboardingConfigPointWithMessage extends OnboardingConfigBase {
	withPoint: true;
	withMessage: true;
	withMoreInfoButton: boolean;
	justPopUp: false;
	messagePosition: SpotlightConfigItem<MessagePosition>;
}

export type OnboardingConfig =
	| OnboardingConfigPopup
	| OnboardingConfigJustPoint
	| OnboardingConfigJustMessage
	| OnboardingConfigPointWithMessage;
